import React from 'react';
import styled from 'styled-components';

const Text = styled.span`
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
`;

function VisiblyHiddenComponent({ text, testId }: { text: string; testId?: string }) {
  return <Text dangerouslySetInnerHTML={{ __html: text }} data-testid={testId} />;
}

const VisiblyHidden = React.memo(VisiblyHiddenComponent);

export default VisiblyHidden;
